export ProductLabel from './ProductLabel';
export ProductBrand from './ProductBrand';
export purchaseCycle from './purchaseCycle';
export DistributionFrequency from './DistributionFrequency'; // 按月配送频次
export ProductPrice from './ProductPrice'; // 商品档案 价格格式化
export ProductState from './ProductState'; // 商品档案 状态格式化
export MiniTime from './MiniTime'; // 商品档案 状态格式化



// WEBPACK FOOTER //
// ./src/common/components/formatter/index.jsx